"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayJournalPk = void 0;
const getDayJournalPk = (accountId, currencyAccountId) => (`${accountId}#${currencyAccountId}`);
exports.getDayJournalPk = getDayJournalPk;
